import {Component, EventEmitter} from '@angular/core';
import {ModalComponent} from '../modal-service.service';
import {PdfPrintSettingsComponent} from './pdf-print-settings/pdf-print-settings.component';
import {FormsModule} from '@angular/forms';

export interface PdfPrintSettings {
    spatialReference: string;
    accessRestriction: boolean;
}

@Component({
    selector: 'nlr-settings-modal',
    imports: [PdfPrintSettingsComponent, FormsModule],
    templateUrl: './settings-modal.component.html',
    styleUrls: ['../modal.scss', './settings-modal.component.scss']
})
export class SettingsModalComponent implements ModalComponent {
    title = 'Pdf Print Settings';

    modalClosed: EventEmitter<string> = new EventEmitter();

    modalSize: string = 'modal-xlg';

    settings: PdfPrintSettings;

    closeDialog() {
        this.modalClosed.emit('Close dialog');
    }
}
